module.exports = __webpack_public_path__ + "static/media/perfil.ca6454a1.svg";